import { render } from "./ButtonRenderer.vue?vue&type=template&id=be78d774"
import script from "./ButtonRenderer.vue?vue&type=script&lang=js"
export * from "./ButtonRenderer.vue?vue&type=script&lang=js"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__